/**
 * Date: 2020-08-13 19:38:02
 * description: 取色器
 *  @author zhizhan
 * Copyright (c) 2019, YUNXI. All rights reserved.
 * YUNXI PROPRIETARY/CONFIDENTIAL. Use is subject to license terms.
 */

import React, { Component } from "react";
import { get, isEqual } from "lodash";
import { YxComponent } from "../../YxComponent";
import propTypes from "prop-types";

export default class ColorPicker extends YxComponent {
  constructor(props) {
    super(props);
    this.state = {
      color: get(this.props, "value", "#ffffff"),
    };
  }
  componentWillReceiveProps(nextProps) {
    const { props } = this;
    if (!isEqual(nextProps.value, props.value)) {
      this.setState({ color: nextProps.value });
    }
  }
  onChange = (event) => {
    this.setState({ color: event.target.value });
    get(this.props, "onChange", () => {})(event);
  };
  render() {
    const { props, state } = this;
    return (
      <div {...props}>
        <input
          type="color"
          value={state.color}
          onChange={this.onChange}
        ></input>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/yx-widget/component/YxInput/ColorPicker/ColorPicker.js